import React from 'react';
import { uppercaseLetters, lowercaseLetters } from './letter-data';

export const strokeDashArrays = {
  up: { a: 190, b: 230, c: 101, d: 194, e: 132, f: 191, g: 145, h: 235, i: 128, j: 174, k: 244, l: 83, m: 176, n: 111, o: 167, p: 203, q: 212, r: 235, s: 100, t: 133, u: 136, v: 100, w: 163, x: 153, y: 162, z: 149 },
  lo: { a: 36, b: 64, c: 17, d: 73, e: 22, f: 59, g: 75, h: 48, i: 16, j: 59, k: 54, l: 33, m: 43, n: 27, o: 17, p: 67, q: 63, r: 24, s: 32, t: 91, u: 28, v: 17, w: 21, x: 24, y: 70, z: 67 },
};

export const viewBoxSizes = {
  up: { a: '46 51', b: '47 51', c: '37 51', d: '45 51', e: '46 51', f: '60 51', g: '40 51', h: '54 51', i: '49 51', j: '53 51', k: '59 51', l: '30 51', m: '49 51', n: '45 51', o: '34 51', p: '52 51', q: '41 51', r: '58 51', s: '46 51', t: '62 51', u: '44 51', v: '41 51', w: '57 51', x: '41 51', y: '35 51', z: '55 51' },
  lo: { a: '13 51', b: '17 51', c: '11 51', d: '20 51', e: '11 51', f: '19 51', g: '23 51', h: '18 51', i: '9 51', j: '23 51', k: '17 51', l: '19 51', m: '19 51', n: '15 51', o: '7 51', p: '20 51', q: '16 51', r: '13 51', s: '14 51', t: '24 51', u: '13 51', v: '9 51', w: '12 51', x: '10 51', y: '21 51', z: '24 51' },
};

export function drawLetter(
  key: string,
  animate: boolean,
  signatureMainRef: React.RefObject<HTMLDivElement | null>,
  prefersReducedMotion: boolean
) {
  if (key === ' ') {
    const space = document.createElement('div');
    space.style.minWidth = '12px';
    signatureMainRef.current?.appendChild(space);
    return;
  }

  const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i));
  const letterIndex = alphabet.findIndex(char => char === key.toLowerCase());
  
  if (letterIndex === -1) return;

  const isUppercase = key === key.toUpperCase();
  const letterData = isUppercase ? uppercaseLetters[letterIndex] : lowercaseLetters[letterIndex];
  const letterClass = letterData.class;
  const dashArray = isUppercase 
    ? strokeDashArrays.up[letterClass as keyof typeof strokeDashArrays.up]
    : strokeDashArrays.lo[letterClass as keyof typeof strokeDashArrays.lo];

  const letterDiv = document.createElement('div');
  letterDiv.className = `${isUppercase ? 'up' : 'lo'} ${letterClass}`;
  letterDiv.style.maxHeight = '51px';
  const viewBox = viewBoxSizes[isUppercase ? 'up' : 'lo'][letterClass as keyof typeof viewBoxSizes.up];
  letterDiv.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 ${viewBox}" height="51" width="${viewBox.split(' ')[0]}">${letterData.svg}</svg>`;
  
  const path = letterDiv.querySelector('svg path');
  if (path) {
    (path as SVGPathElement).style.strokeDasharray = `${dashArray}`;
    (path as SVGPathElement).style.strokeDashoffset = `${dashArray}`;
    (path as SVGPathElement).style.strokeLinejoin = 'round';
    (path as SVGPathElement).style.strokeLinecap = 'round';
    (path as SVGPathElement).style.strokeWidth = '1';
    (path as SVGPathElement).style.stroke = '#fff';
    (path as SVGPathElement).style.transition = prefersReducedMotion ? 'none' : '0.2s stroke-dashoffset';

    if (animate && !prefersReducedMotion) {
      setTimeout(() => {
        (path as SVGPathElement).style.strokeDashoffset = '0';
      }, 50);
    } else {
      (path as SVGPathElement).style.strokeDashoffset = '0';
    }
  }

  signatureMainRef.current?.appendChild(letterDiv);
}

